export function formatCurrency(amount: number): string {
  if (amount === undefined || amount === null) {
    return "";
  }

  // Convert to fixed decimal format and then format with commas and currency symbol
  return "$" + amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "";
}

/**
 * Default funnel price-display cap (USD), used when a tenant's appConfig omits
 * `quoteDisplayCap`. Single source for the default so consumers don't each
 * hard-code the literal.
 */
export const DEFAULT_QUOTE_DISPLAY_CAP = 15000;

/**
 * Format a quoted figure, clamping anything above `cap` to "$<cap>+" so no
 * number over the cap is ever shown in the funnel (full-cap behavior). Used by
 * the quote summary and the photos welcome modal to honor `quoteDisplayCap`.
 */
export function formatCappedCurrency(amount: number, cap: number): string {
  return amount > cap ? `${formatCurrency(cap)}+` : formatCurrency(amount);
}
